export function HalfHandle() {
    return `<svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle opacity="0.7" cx="3.5" cy="3.5" r="3" fill="white" fill-opacity="0.4" stroke="white"/>
            </svg>`;
}
